/**
 * order_number_field_controller.js — the new-job form's client order number,
 * shown only for a client that issues purchase orders (Stimulus).
 *
 * Most clients never issue one, so the field stays out of their way. The
 * selected client's option carries data-issues-purchase-orders (rendered by
 * components/forms/_client_site_fields.html); this follows the client select
 * the same way contact_picker_controller.js does. The server-side rule for
 * saved jobs and invoices is offers_client_order_number
 * (application/utils/client_order_number.py); a form choosing its client has
 * no record yet, so it reads the client alone.
 *
 * A hidden field is disabled as well, so a number typed for one client is not
 * submitted after switching to another.
 *
 * Markup contract:
 *   <div data-controller="order-number-field" data-client-select="#job-client-select">
 *     <input name="client_order_number">
 *   </div>
 */
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    connect() {
        this.clientSelect = document.querySelector(this.element.dataset.clientSelect);
        this.input = this.element.querySelector('input');
        this._onClientChange = () => this.sync();
        if (this.clientSelect) this.clientSelect.addEventListener('change', this._onClientChange);
        this.sync();
    }

    disconnect() {
        if (this.clientSelect) this.clientSelect.removeEventListener('change', this._onClientChange);
    }

    sync() {
        const option = this.clientSelect && this.clientSelect.options[this.clientSelect.selectedIndex];
        const offered = !!(option && option.dataset.issuesPurchaseOrders === 'true');
        this.element.classList.toggle('d-none', !offered);
        if (this.input) this.input.disabled = !offered;
    }
}
